<template>
  <div
    v-if="$vuetify.breakpoint.smAndUp"
    class="d-flex align-center top-bar-internal"
  >
    <v-tooltip
      v-if="$store.getters.authenticated && !$store.getters.sharePreview"
      nudge-bottom="10px"
      bottom
    >
      <template #activator="{ on }">
        <v-btn
          outlined
          rounded
          color="white"
          class="top-bar-pill top-bar-pill--outline"
          exact-active-class="no-highlight"
          v-on="on"
          @click="openArticles"
        >
          <v-icon left>
            view_list
          </v-icon>
          {{ $t('topBar.articles') }}
        </v-btn>
      </template>
      <span>{{ $t('topBar.articles') }}</span>
    </v-tooltip>
    <v-btn
      v-if="$store.getters.sharePreview"
      depressed
      rounded
      color="accent"
      class="top-bar-pill top-bar-pill--solid"
      @click="goRegister"
    >
      <v-icon left>
        person_add
      </v-icon>
      {{ $store.getters.authenticated ? $t('share.openOwn') : $t('share.register') }}
    </v-btn>
    <div
      v-if="showArticleControl"
      class="top-bar-article-actions d-flex flex-nowrap align-center"
    >
      <v-tooltip
        v-for="link of links"
        :key="link.label"
        nudge-bottom="10px"
        bottom
      >
        <template #activator="{ on }">
          <v-btn
            depressed
            rounded
            class="top-bar-pill top-bar-pill--solid"
            :color="link.color || 'accent'"
            :disabled="link.disabled"
            v-on="on"
            @click="link.action()"
          >
            <v-icon left>
              {{ link.icon }}
            </v-icon>
            {{ $t(link.label) }}
          </v-btn>
        </template>
        <span>{{ $t(link.label) }}</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script lang="ts">
    import {EventBus} from "@/utils/EventBus";
    import Vue from "vue";

    interface Link {
        icon: string;
        label: string;
        color?: string;
        action: () => void;
        disabled: boolean;
    }

    export default Vue.extend({
        name: "TopBarInternalLinks",
        props: {
            articleStep: {
                type: Number,
                default: null
            },
            disableSave: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            links(): Array<Link> {
                const links: Array<Link> = [];
                if (this.$route.name === 'Article' && this.articleStep === 3 && !this.$store.getters.sharePreview) {
                    links.push({
                        icon: 'save',
                        label: 'article.save',
                        color: 'accent',
                        action: this.saveArticle,
                        disabled: this.disableSave
                    });
                }
                return links;
            },
            showArticleControl(): boolean {
                return this.$route.name === "Article" && this.articleStep === 3 && !this.$store.getters.sharePreview;
            }
        },
        methods: {
            openArticles(): void {
                this.$route.path !== '/' ? this.$router.push('/') : null;
            },
            saveArticle(): void {
                EventBus.$emit("save");
            },
            goRegister(): void {
                this.$store.commit('clearSharePreview');
                this.$router.push({name: 'Home'});
            }
        }
    });
</script>

<style scoped lang="sass">
.top-bar-internal
    gap: 10px

.top-bar-article-actions
    gap: 10px

.top-bar-pill
    height: 44px !important
    min-width: 0 !important
    padding: 0 20px !important
    font-weight: 700 !important
    letter-spacing: 0.04em !important
    white-space: nowrap

.top-bar-pill--outline
    border: 2px solid #ffffff !important
    box-shadow: inset 0 0 0 1px #ffffff
    color: #fff !important
    background: transparent !important
    caret-color: #fff !important

    .v-icon
        color: #fff !important

.top-bar-pill--solid
    color: #fff !important

    .v-icon
        color: #fff !important
</style>
